import { render, staticRenderFns } from "./CommunityPackageManageConfirmModal.vue?vue&type=template&id=f16fa1b4&"
import script from "./CommunityPackageManageConfirmModal.vue?vue&type=script&lang=js&"
export * from "./CommunityPackageManageConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPackageManageConfirmModal.vue?vue&type=style&index=0&id=f16fa1b4&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports